import { DataPlugin } from '../core/Data';

import { setCookie, getCookie } from '../core/utils';
import PaellaCoreDataPlugins from './PaellaCoreDataPlugins';

export default class CookieDataPlugin extends DataPlugin {
    getPluginModuleInstance() {
        return PaellaCoreDataPlugins.Get();
    }

    get name() {
        return "es.upv.paella.cookieDataPlugin";
    }
    
    serializeKey(context: string, params: any) {
        if (typeof(params) === "object") {
            params = JSON.stringify(params);
        }
        return `${context}|${params}`;
    }

    async read(context: string, keyParams: string) {
        const key = this.serializeKey(context, keyParams);
        let value = getCookie(key);
        try {
            value = JSON.parse(value);
        }
        catch (e) {}
        this.player.log.debug(`CookieDataPlugin.read: ${key}`);
        return value;
    }

    async write(context: string, keyParams: string, data: any) {
        const key = this.serializeKey(context, keyParams);
        if (data && typeof(data) === "object") {
            try {
                data = JSON.stringify(data);
            }
            catch (e) {
                this.player.log.warn(`CookieDataPlugin.write: ${key}: invalid data object.`);
                data = "";
            }
        }
        setCookie(key, data);
        this.player.log.debug(`CookieDataPlugin.write: ${key}`);
    }

    async remove(context: string, keyParams: string) {
        const key = this.serializeKey(context, keyParams);
        setCookie(key, "");
        this.player.log.debug(`CookieDataPlugin.remove: ${key}`);
    }
}
